<!-- header -->
<header id="mainheader" style="background-color:{{background}}">
  <div></div>
  <div class="saludo">
    <ng-container *ngIf="nombres && apellidos">
      <p>
        Bienvenido
        <span>{{ nombres | titlecase }} {{ apellidos | titlecase }}</span>
      </p>
    </ng-container>
  </div>

  <div class="logo">
    <img src="assets/img/logo.png" alt="" />
  </div>
</header>
<!-- /header -->
